export default __webpack_public_path__ + "static/media/rightGrey.d595a1dd.svg";